import { AxiosResponse } from "axios";
import { Flash } from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { partnerApi } from "../services/Api/Partner/partnerApi";
import { FileAttachmentApi } from "../services/Api/types";

export const downloadFileWithAccessToken = (fileItem: FileAttachmentApi) => {
	const link = document.createElement("a");
	if (fileItem.url) {
		link.href = `${fileItem.url}?access_token=${localStorage.getItem("token")}`;
		link.setAttribute("download", `${fileItem.name}`);
		document.body.appendChild(link);
		link.click();
	} else {
		const bs = atob(fileItem.content);
		const buffer = new ArrayBuffer(bs.length);
		const ba = new Uint8Array(buffer);
		for (let i = 0; i < bs.length; i++) {
			ba[i] = bs.charCodeAt(i);
		}
		const blob = new Blob([ba], { type: fileItem.name.split(".")[1] });
		link.href = window.URL.createObjectURL(blob);
		link.download = fileItem.name;
		link.click();
	}
};

export const downloadFile = async (
	fetchData: () => Promise<AxiosResponse<any, any>>,
	name: string,
	addFlash: (_: Flash) => void
) => {
	try {
		const res = await fetchData();
		const url = window.URL.createObjectURL(new Blob([res.data]));
		const link = document.createElement("a");
		link.href = url;
		link.setAttribute("download", name);
		document.body.appendChild(link);
		link.click();
	} catch (err) {
		handleError.alert(err, addFlash);
	}
};
